import Recat, { createContext, useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const { token, user } = useSelector((state) => state.auth);
  useEffect(() => {
    if (token) {
      localStorage.setItem("accessToken", token);
    } else {
      localStorage.removeItem("accessToken");
    }
    if (user) {
      localStorage.setItem("userData", JSON.stringify(user));
    } else {
      localStorage.removeItem("userData");
    }
  }, [token, user]);
  const value = {
    isLoggedIn: !!token,
    userData: user,
    token: token
  };
  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
